import { root, id } from './customers';
import * as idEndpoints from './id';

export const customers = {
  ...root,
  id: {
    ...id,
    ...idEndpoints,
  },
};
